export default "__VITE_ASSET__D2Hq51sB__"